import { takeLatest, put, call } from 'redux-saga/effects'

import {
  GET_ACCESS_CODE_REQUEST,
  GET_ACCESS_CODE_SUCCESS,
  GET_ACCESS_CODE_FAILURE,
  GET_FORGET_PASSWORD_REQUEST,
  GET_FORGET_PASSWORD_SUCCESS,
  GET_FORGET_PASSWORD_FAILURE,
} from '../constants/constant.action'
import { api } from '../services'

function* getAccessCodeSaga(action) {
  try {
    const result = yield call(api.getAccessCodeRequest, action.payload)
    if (result && result.status !== 200)
      throw new Error(result.response.data.error.message)
    yield put({
      type: GET_ACCESS_CODE_SUCCESS,
      payload: result.data,
    })
  } catch (error) {
    yield put({ type: GET_ACCESS_CODE_FAILURE, payload: error })
  }
}

export function* getAccessCodeWatcherSaga() {
  yield takeLatest(GET_ACCESS_CODE_REQUEST, getAccessCodeSaga)
}

function* getForgetPasswordSaga(action) {
  try {
    const result = yield call(api.getForgetPasswordRequest, action.payload)

    if (result.status !== 200)
      throw new Error(result.response.data.error.message)

    yield put({
      type: GET_FORGET_PASSWORD_SUCCESS,
      payload: result,
    })
  } catch (error) {
    yield put({ type: GET_FORGET_PASSWORD_FAILURE, payload: error })
  }
}

export function* getForgetPasswordSagaWatcherSaga() {
  yield takeLatest(GET_FORGET_PASSWORD_REQUEST, getForgetPasswordSaga)
}
